<template>
  <div id="app" class="editable">
    <!-- <top-menu></top-menu> -->
    <router-view/>
  </div>
</template>

<script>
  import $ from 'jquery'
  // import TopMenu from '@/components/Menu/TopMenu'
  // import { isMobile } from 'mobile-device-detect'
  // import platform from 'platform'
  import { loginMixin } from './mixins'
  import { platformMixin } from './components/_Mixins'



  export default {
    name: 'App',

    mounted() {
      //console.log(this.$route.query.SessionID)

    },

    methods: {

    },

    computed: {
      is_course_route() {
        if (this.$route) {
          return this.$route.name == 'Course'
        }

        return false
      }
    },

    mixins: [ loginMixin, platformMixin ],

    // components: {
    //   'slider-menu': Slide,
    // },

    // beforeRouteEnter (to, from, next) {
    //   console.log('beforeRouteEnter', to, from)
    //   next(false)
    // },

    // beforeRouteUpdate (to, from, next) {
    //   console.log('beforeRouteUpdate', to, from)
    //   next()
    // },

    // beforeRouteLeave (to, from, next) {
    //   next()
    // },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue